<div class="p-4">
  <div
    class="flex flex-wrap gap-3 justify-start"
  >
    @for (style of panelStylesService.availableStyles(); track style) {
      <div
        class="color-swatch flex flex-col items-center border rounded-md p-2 cursor-pointer transition-all w-28 md:w-28"
        [class.selected]="style === panelStylesService.selectedStyle()"
        (click)="selectStyle(style)"
      >
        <div class="swatch-box w-25 h-25 md:w-25 md:h-25 mb-1 rounded flex items-center justify-center">
          <img
            src="images/styles/{{style}}.jpg"
            alt="Panel Style {{ style }}"
            class="max-w-full max-h-full object-contain"
          />
        </div>

        <div class="text-xs text-center truncate w-full">
          <strong>{{ style }}</strong>
        </div>
      </div>
    }
  </div>
</div>
